import { useState, useEffect } from 'react';
import CertificateTypeModal from '../../components/CertificateTypeModal/CertificateTypeModal';
import { DataTable } from '../../../../components/DataTable/DataTable';
import ActionsTable from '../../../../components/GenericComponents/ActionsTable';
import { useCertificateTypes } from '../../hooks/useCertificateTypes';
import toast from 'react-hot-toast';
import { TOAST_SUCCESS_IDS, TOAST_ERROR_IDS } from '../../../../interaces/toast.ids.interface';
import { certificateTypesApi } from '../../api/certificateTypes.api';
import { FaFile } from 'react-icons/fa6';
import { MODE } from '../../../../interaces/mode.interface';
import { updateDataWhenDelete } from '../../../../services/helpers';
import { ENUM_CONFIGURATION_CERTIFICATES } from '../../interfaces/certificateTypes';
import { ENUM_PERMISSIONS } from '../../../../interaces/enums/enums.interface';
import { useAuth } from '../../../../context/AuthContext';
import styles from '../../styles/styles.module.css';
function CertificateTypes({ setCertificateTypeId = null, setActiveTab = null }) {
  const [openModal, setOpenModal] = useState(false);
  const [mode, setMode] = useState(MODE.CREATE);
  const { hasPrivilege } = useAuth();

  //DataTable
  const [model, setModel] = useState(null);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const {
    entities,
    setEntities,
    fetchSearch: fetchCertificateTypes,
    loading,
    searchValue,
    setSearchValue,
    onClear,
    dataPagination,
    setPageData,
    pageData,
    dataFilters,
    setDataFilters,
  } = useCertificateTypes();

  useEffect(() => {
    fetchCertificateTypes();
  }, []);

  const handleDelete = async () => {
    try {
      await certificateTypesApi.remove(model.id);
      toast.success(TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY, {
        id: TOAST_SUCCESS_IDS.RECORD_DELETED_SUCCESSFULLY,
      });
      updateDataWhenDelete(setEntities, model.id);
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.ERROR_TO_DELETE_RECORD, {
        id: TOAST_ERROR_IDS.ERROR_TO_DELETE_RECORD,
      });
    } finally {
      setOpenModalConfirmation(false);
    }
  };

  const handleEdit = (item) => {
    setModel(item);
    setOpenModal(true);
    setMode(MODE.UPDATE);
  };

  const columns = [
    {
      accessorKey: 'name',
      header: 'NOMBRE',
    },
    {
      accessorKey: 'description',
      header: 'DESCRIPCIÓN',
    },
    {
      accessorKey: 'xsd',
      header: 'XSD',
      cell: ({ row }) => {
        const xsd = row.original.xsd;
        const name = row.original.name;
        return <>{xsd ? 'XSD-' + name : 'Por asignar XSD'}</>;
      },
    },
    {
      accessorKey: 'active',
      header: 'ESTADO',
      cell: ({ row }) => {
        const status = row.original.active;
        return (
          <span
            className={`
             status-register
              ${status ? 'status-color-active' : 'status-color-inactive'}
            `}
          >
            {status ? 'ACTIVO' : 'INACTIVO'}
          </span>
        );
      },
    },
    {
      accessorKey: 'indefiniteValidity',
      header: 'VIGENCIA',
      cell: ({ row }) => {
        const indefiniteValidity = row.original.indefiniteValidity;
        const totalDays = row.original.totalDays;

        return <>{indefiniteValidity ? 'Indefinida' : totalDays + ' días'}</>;
      },
    },
    ...(hasPrivilege(ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_UPDATE) ||
    hasPrivilege(ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_DELETE)
      ? [
          {
            id: 'acciones',
            header: 'ACCIONES',
            cell: ({ row }) => {
              const item = row.original;
              return (
                <div className="div-actions">
                  {' '}
                  <ActionsTable
                    canDelete={false}
                    handleEdit={() => handleEdit(item)}
                    tienePermisoEditar={hasPrivilege(
                      ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_UPDATE
                    )}
                    tienePermisoEliminar={hasPrivilege(
                      ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_DELETE
                    )}
                    onDelete={() => {
                      setModel(item);
                      setOpenModalConfirmation(true);
                    }}
                  />
                  {!item.xsd &&
                    hasPrivilege(ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_XSD_CREATE) && (
                      <button
                        type="button"
                        title="Añadir XSD"
                        className={styles.btnIconFaFile}
                        onClick={() => {
                          setCertificateTypeId(item.id);
                          setActiveTab(ENUM_CONFIGURATION_CERTIFICATES.XSD);
                        }}
                      >
                        <FaFile className={styles.iconFaFile} />
                      </button>
                    )}
                </div>
              );
            },
          },
        ]
      : []),
  ];

  //
  return (
    <div>
      <DataTable
        columns={columns}
        data={entities}
        searchPlaceholder="Buscar tipo de certificado..."
        pageSize={4}
        loading={loading}
        emptyMessage="No hay registros"
        onRowClick={(data) => {}}
        showSearch={true}
        showPagination={true}
        onSearch={() => fetchCertificateTypes()}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        showCreate={hasPrivilege(ENUM_PERMISSIONS.MOD_CERTIFICATE_CONFIGURATION_TYPE_CREATE)}
        setOpenModal={setOpenModal}
        onClear={() => onClear()}
        showFilters={true}
        dataFilters={dataFilters}
        setDataFilters={setDataFilters}
        numberFilters={1}
        setMode={setMode}
        setModel={setModel}
        dataPagination={dataPagination}
        setPageData={setPageData}
        pageData={pageData}
      />

      {openModal && (
        <CertificateTypeModal
          onClose={() => setOpenModal(false)}
          model={model}
          mode={mode}
          setEntities={setEntities}
        />
      )}
    </div>
  );
}

export default CertificateTypes;
